<section class="notification-settings">
  <h6 i18n>Email notifications</h6>
  @if (isLoading) {
    <mat-spinner [diameter]="24"></mat-spinner>
  } @else if (loadFailed) {
    <p class="unavailable" i18n>
      Notification preferences aren't available for this account yet. You'll receive all default email notifications.
    </p>
  } @else {
    <div class="toggles">
      @for (row of toggles; track row.setting) {
        <app-slide-toggle
          [checked]="isChecked(row)"
          [disabled]="savingKey !== null && savingKey !== row.setting"
          [loading]="savingKey === row.setting"
          [label]="row.label"
          (checkedChange)="handleToggle(row, $event)"
        ></app-slide-toggle>
      }
    </div>
  }
</section>
